function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "User Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.5003,8.5 C12.9263,8.5 13.0003,14.935 13.0003,15 C13.0003,15.276 12.7763,15.5 12.5003,15.5 L0.5003,15.5 C0.2233,15.5 0.0003,15.276 0.0003,15 L0.000779185185,14.9727409 C0.0122911111,14.51315 0.2885,8.5 6.5003,8.5 Z M6.5003,9.5 C1.9853,9.5 1.1763,13.137 1.0313,14.5 L11.9673,14.5 C11.8183,13.137 10.9983,9.5 6.5003,9.5 Z M6.499,0.5 C8.429,0.5 9.999,2.07 9.999,4 C9.999,5.93 8.429,7.5 6.499,7.5 C4.569,7.5 2.999,5.93 2.999,4 C2.999,2.07 4.569,0.5 6.499,0.5 Z M6.499,1.5 C5.121,1.5 3.999,2.622 3.999,4 C3.999,5.378 5.121,6.5 6.499,6.5 C7.877,6.5 8.999,5.378 8.999,4 C8.999,2.622 7.877,1.5 6.499,1.5 Z",
  id: "user-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "user-Icon/Global/user",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-Swatches/DarkGreen",
  transform: "translate(5.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "user-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#user-path-1"
})));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.2b181048.svg";
export { ForwardRef as ReactComponent };